import React, { Component } from 'react'
import { connect } from 'react-redux'
import { removeSelectedItems } from '@disco/state-management/actions/ShortlistActions'
import { PHONE } from '@disco/constants/DeviceTypes'
import type { RootState } from 'store/configureStore'
import { DropdownMenu } from 'components/ds'

type Props = {
  shortlistId: string
  itemIndex: number
  removeSelectedItems: typeof removeSelectedItems
  mobileDeviceType: string
}

class RemoveFromShortlist extends Component<Props> {
  render() {
    if (this.props.mobileDeviceType !== PHONE) return null
    return (
      <DropdownMenu.Item
        onSelect={() =>
          this.props.removeSelectedItems(this.props.shortlistId, [
            this.props.itemIndex,
          ])
        }
      >
        Remove from shortlist
      </DropdownMenu.Item>
    )
  }
}

export default connect(
  (state: RootState) => ({ mobileDeviceType: state.app.mobileDeviceType }),
  { removeSelectedItems },
)(RemoveFromShortlist)
